import { getProjectScopeByRoute } from '../../../redux/projects/projects.selectors';
import { Dispatch, GetState } from '../../../redux/redux.types';
import {
  FlowVersion,
  FlowVersionCreatePayload,
} from '../../../types/flow.types';
import { FlowVersionDetailsFormData } from '../flow-details-panel/flow/form.types';
import * as flowsService from '../flows.service';

import { getSelectedFlowId } from './flows.selectors';

export const FLOW_VERSION_ACTION_NAMES = {
  SAVE_START: 'FLOW_VERSIONS_LIST_ACTION_NAMES.SAVE_START',
  SAVE_SUCCESS: 'FLOW_VERSIONS_LIST_ACTION_NAMES.SAVE_SUCCESS',
  SAVE_ERROR: 'FLOW_VERSIONS_LIST_ACTION_NAMES.SAVE_ERROR',

  GET_START: 'FLOW_VERSIONS_LIST_ACTION_NAMES.GET_START',
  GET_SUCCESS: 'FLOW_VERSIONS_LIST_ACTION_NAMES.GET_SUCCESS',
  GET_ERROR: 'FLOW_VERSIONS_LIST_ACTION_NAMES.GET_ERROR',

  ACTIVATE_VERSION_START:
    'FLOW_VERSIONS_LIST_ACTION_NAMES.ACTIVATE_VERSION_START',
  ACTIVATE_VERSION_SUCCESS:
    'FLOW_VERSIONS_LIST_ACTION_NAMES.ACTIVATE_VERSION_SUCCESS',
  ACTIVATE_VERSION_ERROR:
    'FLOW_VERSIONS_LIST_ACTION_NAMES.ACTIVATE_VERSION_ERROR',
};

export function getFlowVersionsList(flowId: string) {
  return (dispatch: Dispatch, getState: GetState) => {
    const projectContext = getProjectScopeByRoute(getState());

    return dispatch({
      types: [
        FLOW_VERSION_ACTION_NAMES.GET_START,
        FLOW_VERSION_ACTION_NAMES.GET_SUCCESS,
        FLOW_VERSION_ACTION_NAMES.GET_ERROR,
      ],
      callApi: () => flowsService.getFlowVersionsList(projectContext, flowId),
    });
  };
}

export interface SaveFlowVersionAdditionalData {
  flowId: string | undefined;
}

export function updateFlowVersion(
  flowVersion: FlowVersion,
  formData: FlowVersionDetailsFormData,
) {
  return (dispatch: Dispatch, getState: GetState): Promise<void> => {
    const flowId = getSelectedFlowId(getState());
    const projectContext = getProjectScopeByRoute(getState());

    if (!flowId) {
      throw new Error('flowId does not exist');
    }

    const payload: FlowVersionCreatePayload = {
      name: 'revision',
      actions: [JSON.parse(formData.jsonString)],
      projectIds: [projectContext.project.id],
      active: flowVersion.active,
      on: {
        type: formData.triggerType,
        bodyFilters: formData.bodyFilters,
      },
    };

    const additionalData: SaveFlowVersionAdditionalData = {
      flowId,
    };

    return dispatch({
      types: [
        FLOW_VERSION_ACTION_NAMES.SAVE_START,
        FLOW_VERSION_ACTION_NAMES.SAVE_SUCCESS,
        FLOW_VERSION_ACTION_NAMES.SAVE_ERROR,
      ],
      additionalData,
      callApi: () =>
        flowsService.createFlowVersion(projectContext, flowId, payload),
    });
  };
}

export interface ActivateFlowVersionAdditionalData {
  flowId: string;
  version: FlowVersion;
}

export function activateFlowVersion(version: FlowVersion) {
  return (dispatch: Dispatch, getState: GetState) => {
    const flowId = getSelectedFlowId(getState());
    const projectContext = getProjectScopeByRoute(getState());

    if (!flowId) {
      throw new Error('flowId does not exist');
    }

    const additionalData: ActivateFlowVersionAdditionalData = {
      flowId,
      version,
    };

    return dispatch({
      types: [
        FLOW_VERSION_ACTION_NAMES.ACTIVATE_VERSION_START,
        FLOW_VERSION_ACTION_NAMES.ACTIVATE_VERSION_SUCCESS,
        FLOW_VERSION_ACTION_NAMES.ACTIVATE_VERSION_ERROR,
      ],
      additionalData,
      callApi: () =>
        flowsService.activateVersion(projectContext, flowId, version.revision),
    });
  };
}
